module.exports = __webpack_public_path__ + "static/media/Helvetica.217fdd2d.svg";